// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"fa035395","122":"59af6ff3","200":"76998b93","221":"e3bea590","239":"c89fb6e4","311":"ebea7272","495":"0e26ab1b","567":"40c05041","744":"5426ad0a","860":"4be7491a","960":"6e40f282"}[chunkId] + ".chunk.js";
};